import {ApiClient} from '@hconnect/apiclient'
import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useMutation, useQueryClient} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE, TasksApiPath} from '../../../consts'
import {DalogActionDto, EditDalogAction} from '../../../types'
import {TasksQueryKey} from '../useTasks'

import {DalogActionQueryKey} from './useDalogAction'

export const useUpdateDalogAction = () => {
  const queryClient = useQueryClient()
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return useMutation<DalogActionDto, AxiosError, EditDalogAction>({
    mutationFn: async (data) => {
      const {id, plantUpmId} = data
      const path = `${TasksApiPath.DALOG_ACTIONS}/${plantUpmId}/dalog-actions/${id}`

      const {data: response} = await ApiClient.axiosInstance.patch<DalogActionDto>(path, data)

      return response
    },
    onError: () => {
      spawnErrorToast(t('dalogActions.message.failedToUpdateDalogAction'))
    },
    onSuccess: () => {
      spawnSuccessToast(t('dalogActions.message.dalogActionUpdated'))
      void queryClient.invalidateQueries({
        queryKey: [DalogActionQueryKey],
        refetchType: 'all'
      })
      void queryClient.invalidateQueries({queryKey: [TasksQueryKey], refetchType: 'all'})
    }
  })
}
